import { get } from "lodash";

export const getNetworkProfileFields = (state) =>
  get(state, ["network", "profile_fields"]);

export const networkIdSelector = (state) => get(state, ["network", "id"]);
